import classNames from "classnames"

import { WidgetLayout } from "layouts/WidgetLayout"
import { ChartEmptyState } from "components/chart/ChartEmptyState"
import { DoughnutSkeleton } from "components/chart/ChartEmptyState/skeletons"
import { DoughnutChart } from "components/common/DoughnutChart"
import { Spinner } from "components/common/Spinner"

import styles from "./index.module.scss"

export interface WidgetVendorOrderStatusData {
  new: number
  confirmed: number
  packed: number
  shipping: number
  fulfilled: number
  denied: number
}

interface WidgetVendorOrderStatusContentProps {
  data: WidgetVendorOrderStatusData
  total: number
  isLoading?: boolean
}

export const WidgetVendorOrderStatusContent = ({
  data,
  total,
  isLoading = false,
}: WidgetVendorOrderStatusContentProps) => {
  return (
    <WidgetLayout title="Statuses" className={styles.widgetWrapper}>
      <div
        className={classNames(styles.widgetContent, {
          [styles.disabled]: isLoading,
        })}
      >
        {total === 0 && !isLoading ? (
          <ChartEmptyState skeleton={<DoughnutSkeleton />} />
        ) : (
          <div className={styles.chartWrapper}>
            <div className={styles.chart}>
              <DoughnutChart
                values={[data.new, data.confirmed, data.packed, data.shipping]}
                colors={["#4ade80", "#43e0f8", "#7e22ce", "#2563eb"]}
              />
              <div className={styles.widgetMainValue}>
                <span className={styles.widgetNote}>ACTIVE ORDERS</span>
                <div className={styles.widgetValueWrapper}>{total}</div>
              </div>
            </div>

            <div className={styles.chartNotesWrapper}>
              <div className={classNames(styles.chartNotesWrapperColumn)}>
                <div className={classNames(styles.chartNote, styles.new)}>
                  <span>New</span>
                  <span className={styles.chartNoteValue}>{data.new}</span>
                </div>
                <div className={classNames(styles.chartNote, styles.confirmed)}>
                  <span>Confirmed</span>
                  <span className={styles.chartNoteValue}>{data.confirmed}</span>
                </div>
                <div className={classNames(styles.chartNote, styles.packed)}>
                  <span>Packed</span>
                  <span className={styles.chartNoteValue}>{data.packed}</span>
                </div>
                <div className={classNames(styles.chartNote, styles.shipping)}>
                  <span>Shipping</span>
                  <span className={styles.chartNoteValue}>{data.shipping}</span>
                </div>
              </div>
              <div className={styles.chartNotesSeparator} />
              <div className={classNames(styles.chartNotesWrapperColumn)}>
                <div className={classNames(styles.chartNote, styles.fulfilled)}>
                  <span>Fulfilled</span>
                  <span className={styles.chartNoteValue}>{data.fulfilled}</span>
                </div>
                <div className={classNames(styles.chartNote, styles.denied)}>
                  <span>Denied</span>
                  <span className={styles.chartNoteValue}>{data.denied}</span>
                </div>
              </div>
            </div>
          </div>
        )}
        {isLoading && (
          <div className={styles.widgetLoader}>
            <Spinner />
          </div>
        )}
      </div>
    </WidgetLayout>
  )
}
